import { RouteLocation } from "../RouteView/routeViewModel"

const MAPBOX_OPTIMIZED_TRIP_URL = 'https://api.mapbox.com/optimized-trips/v1/mapbox/driving'
const MAPBOX_DIRECTIONS_URL = 'https://api.mapbox.com/directions/v5/mapbox/driving'


export const getOptimizedTrip = async (coords: number[][], startingLocation:RouteLocation | undefined, endingLocation:RouteLocation | undefined, addEndingLocation:boolean) => {
  const query = coords.map(coord => coord.join(',')).join(';')
  const source = startingLocation ? 'source=first&' : ''
  const destination = endingLocation ? 'destination=last&' : ''
  const roundtrip = addEndingLocation ? 'roundtrip=true&' : 'roundtrip=true&'
  const steps = 'steps=true&'
  const overview = 'overview=full&'
  const url = `${MAPBOX_OPTIMIZED_TRIP_URL}/${query}?${source}${destination}${roundtrip}${steps}${overview}geometries=geojson&access_token=${(window as any).env.MAPBOX_ACCESS_TOKEN}`
  const response = await fetch(url)
  return await response.json()
}

const fetchDirectionsChunk = async (coords: number[][]) => {
  const query = coords.map(coord => coord.join(',')).join(';');
  const straight = 'continue_straight=false&'
  const url = `${MAPBOX_DIRECTIONS_URL}/${query}?${straight}geometries=geojson&steps=true&overview=full&access_token=${(window as any).env.MAPBOX_ACCESS_TOKEN}`;
  const response = await fetch(url);
  return await response.json();
}

export const getDrivingDirections = async (coords: number[][]) => {
  const MAX_COORDS = 12

  if (coords.length <= MAX_COORDS) {
    return await fetchDirectionsChunk(coords)
  }

  const chunks: number[][][] = []
  for (let i = 0; i < coords.length; i += MAX_COORDS - 1) {
    const chunk = coords.slice(i, i + MAX_COORDS)
    if (chunk.length >= 2) {
      chunks.push(chunk)
    }
  }

  const results = await Promise.all(chunks.map(chunk => fetchDirectionsChunk(chunk)))

  let totalDuration = 0
  let totalDistance = 0
  const combinedCoordinates: number[][] = []

  for (let i = 0; i < results.length; i++) {
    const result = results[i]
    if (result && result.routes && result.routes[0] && result.routes[0].geometry) {
      totalDuration += result.routes[0].duration || 0
      totalDistance += result.routes[0].distance || 0

      const routeCoords = result.routes[0].geometry.coordinates
      if (routeCoords && routeCoords.length > 0) {
        if (combinedCoordinates.length === 0) {
          combinedCoordinates.push(...routeCoords)
        } else {
          combinedCoordinates.push(...routeCoords.slice(1))
        }
      }
    } else if (result && result.code && result.code !== 'Ok') {
      console.warn(`Mapbox directions chunk ${i + 1}/${chunks.length} failed:`, result.message || result.code)
    }
  }

  if (combinedCoordinates.length === 0) {
    return { routes: [] }
  }

  return {
    routes: [{
      duration: totalDuration,
      distance: totalDistance,
      geometry: {
        type: 'LineString',
        coordinates: combinedCoordinates
      }
    }]
  }
}

export const getGeocoding = async (address: string) => {
  const url = `https://api.mapbox.com/search/geocode/v6/forward?q=${address}&permanent=false&format=geojson&types=address&access_token=${(window as any).env.MAPBOX_ACCESS_TOKEN}`;
  const response = await fetch(url);
  const result = await response.json();
  return result.features?.[0];
}